import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { MadiAuthenticationDto } from '..//models/MadiAuthentication.model';
import { UserProfileDto } from '../models/UserProfile.model';

@Injectable()

export class SecurityEndpoint extends EndpointFactory {
  private readonly logInEndpointPath: string = "/api/security/logIn";
  private readonly resetPasswordEndpointPath: string = "/api/security/resetPassword";
  private readonly validatePasswordEndpointPath: string = "/api/security/validatePassword";
  private readonly changePasswordEndpointPath: string = "/api/security/changePassword";
  private readonly unlockWebAccountEndpointPath: string = "/api/security/unlockWebAccount";
  
  private readonly getMadiPropertiesEndpointPath: string = "/api/security/getMadiProperties";
  private readonly getUserProfileByExternalLoginIdEndpointPath: string = "/api/security/getUserProfileByExternalLoginId";

  private readonly getLoggedInUserProfileEndpointPath: string = "/api/security/getUserProfileByUserIdentity";
  private readonly getRoleForUserAndRegulatoryItemEndpointPath: string = "/api/security/getRoleForUserAndRegulatoryItem";
  private readonly submitUserProfileRequestEndpointUrl: string = "/api/userAccessService/submitUserProfileRequest";

  get getLoggedInUserProfileEndpointPathEndpointUrl() { return this.configurations.baseUrl + this.getLoggedInUserProfileEndpointPath; }
  get getRoleForUserAndRegulatoryItemEndpointPathEndpointUrl() { return this.configurations.baseUrl + this.getRoleForUserAndRegulatoryItemEndpointPath; }
  get getMadiPropertiesEndpointPathEndpointUrl() { return this.configurations.baseUrl + this.getMadiPropertiesEndpointPath; }
  get getUserProfileByExternalLoginIdEndpointPathEndpointUrl() { return this.configurations.baseUrl + this.getUserProfileByExternalLoginIdEndpointPath; }
  get logInEndpointPathEndpointUrl() { return this.configurations.baseUrl + this.logInEndpointPath; }
  get resetPasswordEndpointPathEndpointUrl() { return this.configurations.baseUrl + this.resetPasswordEndpointPath; }
  get validatePasswordEndpointUrl() { return this.configurations.baseUrl + this.validatePasswordEndpointPath; }
  get changePasswordEndpointUrl() { return this.configurations.baseUrl + this.changePasswordEndpointPath; }
  get unlockWebAccountEndpointUrl() { return this.configurations.baseUrl + this.unlockWebAccountEndpointPath; }
  

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);

  }

  getMadiPropertiesEndpoint(): Observable<MadiAuthenticationDto> {
    console.log(this.configurations.baseUrl);
    return this.http.get<MadiAuthenticationDto>(this.getMadiPropertiesEndpointPathEndpointUrl);
  }

  getUserProfileByExternalLoginId(myAlbertaPersistentId?: string): Observable<UserProfileDto> {
    let endpointUrl = `${this.getUserProfileByExternalLoginIdEndpointPathEndpointUrl}/${myAlbertaPersistentId}`;
    return this.http.get<UserProfileDto>(endpointUrl);
  }

  getLoggedInUserProfile(): Observable<UserProfileDto> {
    let endpointUrl = `${this.getLoggedInUserProfileEndpointPathEndpointUrl}`;
    return this.http.get<UserProfileDto>(endpointUrl);
  }

  getRoleForRegulatoryItem(userProfileId: string, regulatoryItemId: string): Observable<number> {
    let endpointUrl = `${this.getLoggedInUserProfileEndpointPathEndpointUrl}/${userProfileId}/${regulatoryItemId}`;
    return this.http.get<number>(endpointUrl);
  }

  submitUserProfileRequest<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.submitUserProfileRequestEndpointUrl}/`;
    //console.log(this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders()));
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }

  logIn(userObject: any): Observable<UserProfileDto> {
    let endpointUrl = `${this.logInEndpointPathEndpointUrl}/`;
    return this.http.post<UserProfileDto>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }

  resetPassword<T>(emailAddress: string): Observable<T> {
    let endpointUrl = `${this.resetPasswordEndpointPathEndpointUrl}/${emailAddress}/`;
    return this.http.get<T>(endpointUrl);
  }
  
  unlockWebAccount<T>(emailAddress: string): Observable<T> {
    let endpointUrl = `${this.unlockWebAccountEndpointUrl}/${emailAddress}/`;
    return this.http.get<T>(endpointUrl);
  }

  validatePassword<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.validatePasswordEndpointUrl}/`;
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }

  changePassword<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.changePasswordEndpointUrl}/`;
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }

}
